<template>
  <section class="networkSearch">
    <div class="inner row3_1 flex mobileFlexCol">
      <article class="wd100">
        <h1 class="mainTitle">
          네트워킹 검색
        </h1>

        <NetworkSearchFilterCorp
          :params="params"
          @onchange="onchange"
          v-if="params.isCorp"
        />

        <NetworkSearchFilterUser :params="params" @onchange="onchange" v-else />

        <!-- fillter -->

        <h5 class="networkSearch__headline">
          총 {{ !this.lodash.isEmpty(items) ? items.length : "0" }}
          {{ params.isCorp ? "개 기업" : "개 회원" }}
        </h5>

        <div class="networkSearchList" v-if="!this.lodash.isEmpty(items)">
          <div
            class="networkSearchList__col"
            v-for="(item, i) in items"
            :key="i"
          >
            <ItemSearchCorp
              v-if="params.isCorp"
              :data="item"
              @viewProfile="viewProfileCorp(item)"
              @showApply="showApplyCorp(item)"
            />
            <ItemSearchUser
              v-else
              :data="item"
              @viewProfile="viewProfileUser(item)"
              @showApply="showApplyUser(item)"
            />
          </div>
        </div>

        <!-- <div>
            <PaginationMatching />
          </div> -->
      </article>
    </div>

    <ViewProfileCompanyPopup
      :data="activeItem"
      :isModal="isShowViewProfileCompanyPopup"
      :handleToggleModal="closeModal"
      :handleOk="showApplyCorp"
    />

    <NTApplyPopup
      :data="activeItem"
      :isModal="isShowNTApplyPopup"
      :handleToggleModal="closeModal"
      :onApply="onApplyCorp"
      :onRequest="onRequestCorp"
    />

    <NTApplyComPopup
      :data="activeItem"
      :isModal="isShowNTApplyComPopup"
      :handleToggleModal="closeModal"
    />

    <NTApplyNAPPopup
      :data="activeItem"
      :isModal="isShowNTApplyNAPPopup"
      :handleToggleModal="closeModal"
    />

    <PopupViewProfilePersonal
      :data="activeItem"
      :isModal="isShowPopupViewProfilePersonal"
      :handleToggleModal="closeModal"
      :handleOk="showApplyUser"
    />

    <PopupApplyForMatching
      :data="activeItem"
      :isModal="isShowPopupApplyForMatching"
      :handleToggleModal="closeModal"
      :onApply="onApplyUser"
      :onRequest="onRequestUser"
    />

    <PopupMatchingRequest
      :data="activeItem"
      :isModal="isShowPopupMatchingRequest"
      :handleToggleModal="closeModal"
    />

    <PopupNAPConsultationApplication
      :data="activeItem"
      :isModal="isShowPopupNAPConsultationApplication"
      :handleToggleModal="closeModal"
    />
  </section>
</template>

<script>
import axios from "@/axios/axios";
// import PaginationMatching from "@/components/general/PaginationMatching.vue";
import NetworkSearchFilterCorp from "@/components/formControl/NetworkSearchFilterCorp.vue";
import NetworkSearchFilterUser from "@/components/formControl/NetworkSearchFilterUser.vue";
import ItemSearchCorp from "@/components/items/ItemSearchCorp.vue";
import ItemSearchUser from "@/components/items/ItemSearchUser.vue";
import ViewProfileCompanyPopup from "./popup/ViewProfileCompanyPopup.vue";
import NTApplyPopup from "./popup/NTApplyPopup.vue";
import NTApplyComPopup from "./popup/NTApplyComPopup.vue";
import NTApplyNAPPopup from "./popup/NTApplyNAPPopup.vue";
import PopupViewProfilePersonal from "./popup/PopupViewProfilePersonal.vue";
import PopupApplyForMatching from "./popup/PopupApplyForMatching.vue";
import PopupNAPConsultationApplication from "./popup/PopupNAPConsultationApplication.vue";
import PopupMatchingRequest from "./popup/PopupMatchingRequest.vue";

export default {
  name: "SearchNetworking",
  components: {
    NetworkSearchFilterCorp,
    NetworkSearchFilterUser,
    ItemSearchUser,
    ItemSearchCorp,
    ViewProfileCompanyPopup,
    NTApplyPopup,
    NTApplyComPopup,
    NTApplyNAPPopup,
    PopupViewProfilePersonal,
    PopupApplyForMatching,
    PopupNAPConsultationApplication,
    PopupMatchingRequest,
  },
  data() {
    return {
      items: [],
      activeItem: null,
      isShowPopupViewProfilePersonal: false,
      isShowViewProfileCompanyPopup: false,
      isShowNTApplyPopup: false,
      isShowNTApplyComPopup: false,
      isShowNTApplyNAPPopup: false,
      isShowPopupApplyForMatching: false,
      isShowPopupNAPConsultationApplication: false,
      isShowPopupMatchingRequest: false,
      params: {
        isCorp: true,
        name: "",
        id: "",
        industryIdx: "",
        activityIdx: "",
        companyType: null,
      },
    };
  },
  mounted() {
    this.getDatas();
  },
  computed: {},
  methods: {
    closeModal() {
      this.activeItem = null;
      this.isShowPopupViewProfilePersonal = false;
      this.isShowViewProfileCompanyPopup = false;
      this.isShowNTApplyPopup = false;
      this.isShowNTApplyComPopup = false;
      this.isShowNTApplyNAPPopup = false;
      this.isShowPopupApplyForMatching = false;
      this.isShowPopupNAPConsultationApplication = false;
      this.isShowPopupMatchingRequest = false;
    },
    onchange(currentParams) {
      this.params = this.lodash.merge(this.params, currentParams);
      this.getDatas();
    },
    getDatas() {
      const that = this;
      axios
        .get("/api/user/searchUser", { params: that.params })
        .then((response) => {
          that.items = response.data;
        })
        .catch((error) => {
          console.log("error: " + error);
          return [];
        });
    },
    viewProfileCorp(item) {
      this.closeModal();
      this.activeItem = item;
      console.log(item);
      this.isShowViewProfileCompanyPopup = true;
    },
    showApplyCorp(item) {
      this.closeModal();
      this.activeItem = item;
      this.isShowNTApplyPopup = true;
    },
    onApplyCorp(item) {
      this.closeModal();
      this.activeItem = item;
      this.isShowNTApplyComPopup = true;
    },
    onRequestCorp(item) {
      this.closeModal();
      this.activeItem = item;
      this.isShowNTApplyNAPPopup = true;
    },
    viewProfileUser(item) {
      this.closeModal();
      this.activeItem = item;
      this.isShowPopupViewProfilePersonal = true;
    },
    showApplyUser(item) {
      this.closeModal();
      this.activeItem = item;
      this.isShowPopupApplyForMatching = true;
    },
    onApplyUser(item) {
      this.closeModal();
      this.activeItem = item;
      this.isShowPopupMatchingRequest = true;
    },
    onRequestUser(item) {
      this.closeModal();
      this.activeItem = item;
      this.isShowPopupNAPConsultationApplication = true;
    },
  },
};
</script>

<style lang="scss" scoped>
// section 2
.directMatching {
  display: flex;
  border-bottom: 1px solid #d6d6d6;
  justify-content: space-between;
}

// Section 2
.btn-outlined {
  height: 53px;
  border: 1px solid #989898;
  background-color: #fff;
  width: 100%;
  font-size: 22px;
  margin-top: 16px;
  cursor: pointer;
}
</style>
